module.exports = __webpack_public_path__ + "img/filters_en.b7691ed.jpg";